import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import 'animate.css';
import Footer from './Footer';
import Slider from '../components/Slider';
import CategorySwiper from '../components/CategorySwiper';
import Banner from '../components/Banner';
import { CartContext } from '../context/CartContext';
import { FavoritesContext } from '../context/FavoritesContext';
import axios from 'axios';
import { toast } from "react-hot-toast";
import { useUser } from '../context/UserContext';
import PromoMarquee from '../components/PromoMarquee';
import SEO from '../components/SEO.jsx';
import { buildOrganizationSchema, buildWebsiteSchema } from '../utils/structuredData';
import { API_URL } from '../config/api';

const backend = API_URL;

export default function HomePage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(true);
  const [jeuxVideos, setJeuxVideos] = useState([]);
  const [psnCards, setPsnCards] = useState([]);
  const [itunesCards, setItunesCards] = useState([]);
  const [nouveautes, setNouveautes] = useState([]);
  const [boutiqueProducts, setBoutiqueProducts] = useState([]);

  const { dispatch: cartDispatch } = useContext(CartContext);
  const { favorites } = useContext(FavoritesContext);
  const { user } = useUser();

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const res = await fetch(`${backend}/products`);
        const data = await res.json();

        const getGroupItems = (groupKeywords) => {
          return data
            .filter(p => {
              const groupe = p.groupe?.toLowerCase();
              return groupKeywords.some(k => groupe?.includes(k));
            })
            .slice(0, 4);
        };

        setJeuxVideos(getGroupItems(['ps4', 'ps5']));
        setPsnCards(getGroupItems(['cartes psn']));
        setItunesCards(getGroupItems(['cartes itunes']));
        setNouveautes(data.filter(p => p.nouveaute === true).slice(0, 4));
           // 🔹 Produits boutique (hors jeux et cartes)
      setBoutiqueProducts(
        data.filter(
          p => !['ps4','ps5','cartes psn','cartes itunes'].includes((p.groupe || '').toLowerCase())
        ).slice(0, 8) // 8 premiers
      );
      } catch (err) {
        console.error('Erreur chargement des produits :', err);
      } finally {
        setLoading(false);
      }
    };

    fetchItems();
  }, []);

  // ✅ Intégration Tawk.to
  // useEffect(() => {
  //   var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
  //   var s1 = document.createElement("script");
  //   s1.async = true;
  //   s1.src='https://embed.tawk.to/689df4d4ed02831924d228cf/1j2kg8obf';
  //   s1.charset = 'UTF-8';
  //   s1.setAttribute('crossorigin','*');
  //   document.body.appendChild(s1);
  // }, []);

  const Card = (prod) => {
    const imgSrc = prod.img?.startsWith('http') ? prod.img : `${backend}/uploads/${prod.img}`;

    return (
       <article key={prod._id} className="pro-card">
                              <Link
                                to={`/product/${prod._id}`}
                                className="pro-imgWrap"
                              >
                                <img
                                  src={prod.img.startsWith('http') ? prod.img : `${API_URL}/uploads/${prod.img}`}
                                  alt={prod.title}
                                />
      
                                <div className="pro-badges">
                                  <span className={`pro-badge ${prod.promotion > 0 ? 'promo' : 'empty'}`}>
                                    {prod.promotion > 0 ? `-${prod.promotion}%` : ' '}
                                  </span>
                                  <span className={`pro-badge ${prod.nouveaute > 0 ? 'nouveaute' : 'empty'}`}>
                                    {prod.nouveaute > 0 ? 'Nouveauté' : ' '}
                                  </span>
                                </div>
                              </Link>
      
                            <div className="pro-info">
                              <h4 className="pro-title">{prod.title}</h4>
                              <p className="pro-meta">
                                {prod.label} • {prod.categorie} • {prod.plateforme || prod.groupe}
                              </p>
      
                                                            <div className="pro-footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
  <div className="pro-price-wrapper" style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
    {prod.promotion > 0 && prod.prixOriginal > 0 ? (
      <>
        <span className="original-price" style={{ textDecoration: 'line-through', color: '#888', fontWeight: '500', fontSize: '0.95rem' }}>
          {Number(prod.prixOriginal).toLocaleString()} FCFA
        </span>
        <span className="promo-price pro-price" style={{ color: '#e53935' }}>
          {Number(prod.price).toLocaleString()} FCFA
        </span>
      </>
    ) : (
      <span className="pro-price">
        {Number(prod.prixOriginal > 0 ? prod.prixOriginal : prod.price).toLocaleString()} FCFA
      </span>
    )}
  </div>

  <div className="pro-actions">
    <button className="circle-btn" onClick={() => cartDispatch({ type: 'ADD_TO_CART', payload: prod })}>
      <i className="fa-solid fa-cart-plus" />
    </button>
  </div>
</div>
                            </div>
                            </article>
    );
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${backend}/subscribe`, { email, adminId: user?._id });
      toast.success("Inscription réussie !");
      setEmail("");
    } catch (err) {
      if (err.response?.status === 409) toast("Vous êtes déjà inscrit.", { icon: "ℹ️" });
      else if (err.response?.status === 400) toast.error("Email ou identifiant manquant.");
      else toast.error("Erreur lors de l'inscription.");
    }
  };

  function LoaderModern() {
    return (
      <div style={styles.loaderContainer}>
        <div style={styles.loader}>
          <div style={{ ...styles.dot, animationDelay: '0s' }}></div>
          <div style={{ ...styles.dot, animationDelay: '0.15s' }}></div>
          <div style={{ ...styles.dot, animationDelay: '0.3s' }}></div>
        </div>
        <p style={styles.loaderText}>Chargement en cours...</p>

        <style>{`
          @keyframes bounce {
            0%, 80%, 100% { transform: scale(0); }
            40% { transform: scale(1); }
          }
        `}</style>
      </div>
    );
  }

  const styles = {
    loaderContainer: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 150, color: '#444', width: '100%' },
    loader: { display: 'flex', gap: 8 },
    dot: { width: 14, height: 14, borderRadius: '50%', backgroundColor: '#007BFF', animation: 'bounce 1s infinite ease-in-out' },
    loaderText: { marginTop: 15, fontSize: '1rem', color: '#007BFF', fontWeight: '600' },
  };

  if (loading) return <div className="container"><LoaderModern /></div>;

  return (
    <>
    <SEO
      title="Accueil"
      description="Vente de jeux vidéo digitaux PS4 & PS5, cartes PSN et cartes iTunes. Téléchargement instantané, paiement sécurisé et avis clients vérifiés sur CodeShop225."
      path="/"
      jsonLd={[buildOrganizationSchema(), buildWebsiteSchema()]}
    />
    {/* <PromoMarquee/> */}
      <div className='containers'>

        <Slider />
        <CategorySwiper />

        {/* Section Nouveautés */}
        <div className='container'>
          <div className="col-12 col-md-12">
            <div className="mb__container">
              <h2 className="mb__title">Nouveautés</h2>
            </div>
            <div className="pro-grid">
              {nouveautes.length === 0 ? <p>Aucun produit nouveauté trouvé.</p> : nouveautes.map(Card)}
            </div>
            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <Link to="/nouveautes" className="btn__homepage">Voir plus</Link>
            </div>
          </div>
        </div>

        {/* ------------------ Section Boutique ------------------ */}
<div className='container'>
  <div className="col-12 col-md-12">
    <div className="mb__container">
      <h2 className="mb__title">Articles Boutique</h2>
    </div>
    <div className="pro-grid">
      <div className="pro-grid">
  {boutiqueProducts.length === 0 ? (
    <p>Aucun article disponible pour le moment.</p>
  ) : (
    // On affiche seulement les 4 derniers ajouts
    boutiqueProducts
      .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0)) // trie du plus récent au plus ancien
      .slice(0, 4)
      .map(Card)
  )}
</div>
    </div>
    <div style={{ textAlign: 'center', marginTop: '20px', marginBottom:'1rem' }}>
      <Link to="/boutique" className="btn__homepage">Voir plus</Link>
    </div>
  </div>
</div>

        {/* Section Jeux Vidéos */}
        <div className='container '>
          <div className="col-12 col-md-12">
            <div className="mb__container"><h2 className="mb__title">Jeux Vidéos</h2></div>
            <div className="pro-grid">
              {jeuxVideos.length === 0 ? <p>Aucun produit jeux vidéos trouvé.</p> : jeuxVideos.map(Card)}
            </div>
            <div style={{ textAlign: 'center', marginTop: '20px', marginBottom:'1rem' }}>
              <Link to="/fr/PS4" className="btn__homepage">Voir plus</Link>
            </div>
          </div>
        </div>

        <Banner />

        {/* Section Cartes */}
        <div className='container'>
          <div className="col-12 col-md-12">
            <div className="mb__container"><h2 className="mb__title">Cartes PSN</h2></div>
            <div className="pro-grid">{psnCards.length === 0 ? <p>Aucune carte PSN trouvée.</p> : psnCards.map(Card)}</div>
            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <Link to="/Cartes__PSN" className="btn__homepage">Voir plus</Link>
            </div>

            <div className="mb__container"><h2 className="mb__title">Cartes iTunes</h2></div>
            <div className="pro-grid">{itunesCards.length === 0 ? <p>Aucune carte iTunes trouvée.</p> : itunesCards.map(Card)}</div>
            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <Link to="/Cartes__itunes" className="btn__homepage">Voir plus</Link>
            </div>
          </div>
        </div>

        {/* Newsletter */}
        <section className="nl">
          <div className="nl__wrap">
            <h3 className="nl__title">Restez informé<span> !</span></h3>
            <p className="nl__text">Promotions exclusives, arrivages, conseils pratiques : un e-mail par semaine, pas de spam.</p>
            <form className="nl__form" onSubmit={handleSubscribe}>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Votre adresse e-mail" required aria-label="Adresse e-mail" />
              <button type="submit">Je m’abonne</button>
            </form>
            <p className="nl__note">En vous inscrivant, vous acceptez notre&nbsp;
              <a href="/policy" target="_blank" rel="noreferrer">politique de confidentialité</a>.
            </p>
          </div>
        </section>

      </div>
      <Footer />

      {/* ✅ Bouton WhatsApp flottant */}
      <a
        href="https://wa.me/2250101885981?text=Bonjour,%20je%20souhaite%20des%20infos%20sur%20vos%20produits"
        target="_blank" rel="noreferrer" className="whatsapp-btn">
        <i className="fab fa-whatsapp"></i>
      </a>
      
    </>
  );
}